import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtrarTexto'
})
export class FiltrarTextoPipe implements PipeTransform {

  transform(array: any[], searchText: string): any[] {

    if (!array) return [];

    if (searchText) {
      searchText = searchText.toLowerCase();
      return array.filter(item => {
        return item.nombre.toLowerCase().includes(searchText);
      });
    }else{
      return [];
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/filtrar-texto.pipe.ts